import React from "react"

const Banner = () => {
  return <div>banner</div>
}

export default Banner
